var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"justify-center mx-2"},[_c('v-col',{staticClass:"my-2",attrs:{"cols":"12","md":"4"}},_vm._l((_vm.menu),function(item,index){return _c('v-btn',{key:index,staticClass:"my-4",attrs:{"block":""},on:{"click":function($event){return _vm.navigate(item.path)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }